import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M6.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75" />
  </>
);

const MinusSm = Icon('minus-sm', svgContents);

export default MinusSm;
